<script lang="ts" setup>
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();
</script>

<template>
    <shared-labeled-field
        v-slot="{ ariaLabelledby }"
        :label="$t('checkout.paymentMethod.label')"
    >
        <VSelect
            v-model="orderStore.currentOrder.paymentMethod"
            :aria-labelledby="ariaLabelledby"
            item-value="id"
            item-title="label"
            :items="orderStore.options.paymentMethods"
        />
    </shared-labeled-field>
</template>
